import { PropsWithChildren } from 'react'

import { ContractsRepository } from '@/Contract/domain'
import {
  IUseContractAccountingStatusController,
  useContractAccountingStatusController,
} from '@/Contract/ui/hooks'
import { createGenericContext } from '@/Shared/ui/createGenericContext'

type Context = {
  repository: ContractsRepository
} & IUseContractAccountingStatusController

type Props = PropsWithChildren & {
  repository: ContractsRepository
  merchantId: number
}

const [useAccountingStatus, StateContextProvider] = createGenericContext<Context>()

const AccountingStatusProvider = ({
  repository,
  merchantId,
  children,
}: Props): JSX.Element => {
  const controller = useContractAccountingStatusController(merchantId, repository)
  return (
    <StateContextProvider value={{ repository, ...controller }}>
      {children}
    </StateContextProvider>
  )
}

export { AccountingStatusProvider, useAccountingStatus }
